import ProgressTestCourseView from './component';
import _routes from './routes';

export const routes = _routes;

export default ProgressTestCourseView;



// WEBPACK FOOTER //
// ./containers/Group/MidtermAndFinalExamHFv4/CourseView/index.js